import React from 'react'
import styled from 'styled-components';
import '../style/custom.css';
import { useTranslation } from 'react-i18next';
import DayVisitorForm from "../components/DayVisitorForm";
import onephoto from "../assets/1.png";
import twophoto from "../assets/2.png";
import threephoto from "../assets/3.png";

const Styles = styled.div`  



`;

const Home = () => {
  const { t } = useTranslation(); // LANGUAGE  

  return (
    <Styles>
      {/* === STEP SECTION ==== */}
      <div className="step-section animate__animated animate__fadeIn">
        <div className="container">

          <div className="row step-bg ">
            <div id="idStepSection1" className="card col background-green cardsize mx-2 animate__animated animate__fadeInDown animate__delay-400ms">
              <div className="card-body mobile-card-size">
                <h5 className="card-title">
                  {/* STEP */}
                  {t('text.1')}
                </h5>
                <img className="card-img-top" src={onephoto} alt="step 1" />
              </div>
            </div>
            <div id="idStepSection2" className="card col cardsize mx-2 animate__animated animate__fadeInDown animate__delay-600ms">
              <div className="card-body mobile-card-size">
                <h5 className="card-title">
                  {/* STEP */}
                  {t('text.1')}
                </h5>
                <img className="card-img-top" src={twophoto} alt="step 2" />
              </div>
            </div>
            <div id="idStepSection3" className="card col cardsize mx-2 animate__animated animate__fadeInDown animate__delay-900ms">
              <div className="card-body mobile-card-size">
                <h5 className="card-title">
                  {/* STEP */}
                  {t('text.1')}
                </h5>
                <img className="card-img-top" src={threephoto} alt="step 3" />
              </div>
            </div>

          </div>

        </div>
      </div>
      {/* === END STEP SECTION ==== */}




      {/* === CONTENT SECTION ==== */}
      <div className="content-section mobile-content-section">
        <div className="container">

          <p className="animate__animated animate__fadeInDown animate__delay-600ms">
            {/* One person per appointment slot. Please note that CPF Tampines Service Centre will be closed for renovation from 6 March 2021 to November 2021. */}
            {t('text.3')}
          </p>


          <div className="animate__animated animate__fadeIn animate__delay-900ms">
            <DayVisitorForm />
          </div>


        </div>
      </div>
      {/* === END CONTENT SECTION ==== */}
    </Styles >
  );
}

export default Home;